import type { FunnelStep } from "../types";

interface FunnelChartProps {
  funnel: FunnelStep[];
}

export function FunnelChart({ funnel }: FunnelChartProps) {
  const maxSessions = Math.max(...funnel.map(s => s.sessions), 1);

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900 p-4 sm:p-6">
      <h2 className="mb-1 text-xs font-bold uppercase tracking-widest text-slate-400">Conversion Funnel</h2>
      <p className="mb-6 text-[10px] text-slate-500">Unique sessions per step · drop-off from prior step</p>

      <div className="space-y-3">
        {funnel.map(step => {
          const widthPct = Math.max((step.sessions / maxSessions) * 100, step.sessions > 0 ? 4 : 0);
          const isPhone = step.step === 5;

          return (
            <div key={step.step}>
              <div className="mb-1 flex items-baseline justify-between gap-2">
                <div className="flex items-center gap-2">
                  <span className="font-mono text-[10px] text-slate-500">S{step.step}</span>
                  <span className="text-sm font-medium text-slate-200">{step.label}</span>
                </div>
                <div className="flex items-center gap-3 text-xs">
                  <span className="font-mono font-semibold text-white">{step.sessions.toLocaleString()}</span>
                  <span className="text-slate-500">{step.conversion_from_top}% of top</span>
                  {step.step > 0 && step.dropoff_from_prior > 0 && (
                    <span className="text-red-400/80">−{step.dropoff_from_prior}%</span>
                  )}
                </div>
              </div>
              <div className="h-7 overflow-hidden rounded-md bg-slate-800">
                <div
                  className={`funnel-bar flex h-full items-center rounded-md px-2 ${
                    isPhone ? "bg-emerald-600" : "bg-slate-600"
                  }`}
                  style={{ width: `${widthPct}%` }}
                >
                  {widthPct > 15 && (
                    <span className="truncate text-[10px] font-medium text-white/90">{step.event_type}</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
